const toBase64 = (file) =>
  new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
  });

export const converters = {
  toBase64,
};



// WEBPACK FOOTER //
// ./src/_shared/utils/converters.js